
































































































































import { Component, Vue } from "vue-property-decorator";
import FileService from "@/services/FileService";
import VueUploadComponent from "vue-upload-component";
// import Datepicker from "vuejs-datepicker";
import VoerroTagsInput from "@voerro/vue-tagsinput";
import { Tags } from "@/models/Tags";

@Component({
  components: {
    VueUploadComponent,
    VoerroTagsInput
  }
})
export default class UploadView extends Vue {
  private fs = new FileService();
  private files = [];

  private title: any = null;
  private tags: any = [];
  private author: any = null;
  private pubDate: any = null;
  private isPrivate = false;

  private existingTags = new Tags().tags.map(r => {
    return { key: r, value: r };
  });

  private async upload() {
    const formData = new FormData();
    const file = (this.$refs.upload as any).get((this.files[0] as any).id);

    formData.append("file", file.file);
    formData.append("name", file.name);

    formData.append("title", this.title);
    formData.append("author", this.author);
    formData.append("is_private", this.isPrivate ? "true" : "false");
    formData.append(
      "tags",
      this.tags.map((r: any) => {
        return r.value;
      })
    );
    formData.append("pubDate", this.pubDate);

    // return await this.fs.uploadFile(formData);
    return await this.fs
      .uploadFile(formData)
      .then(() => {
        this.$router.push("/");
      })
      .catch(() => {
        this.$router.push("/");
        // return { status: "failure" };
      });
  }
}
